import styles from './S02.module.css';
import emergencyImg from './images/02-emergency.png';
import pathImg from './images/02-path.png';
import Button from '../Button/Button';
import Video from '../Video/Video';

import card1 from './images/02-working1.png';
import card2 from './images/02-working2.png';
import card3 from './images/02-working3.png';

import video1 from './images/02-video1.jpg';
import video2 from './images/02-video2.jpg';
import video3 from './images/02-video3.jpg';

export default function S02(){

  return <div className={styles.main}>
  <div className={styles.emergency}>
    <img src={emergencyImg} alt="" />
    <div className={styles.info}>
      <h3>What is an emergency?</h3>
      <p>We define emergencies as exceptional events that cause human suffering or pose an imminent threat to human lives or livelihoods, dislocating community life and exceeding the remediation capacity of the responsible governments. COVID-19 is one of few global emergencies in recent times. But pandemics, natural disasters, financial crises, industrial accidents and international terrorist attacks have all affected large parts of the globe in this century.</p>
    </div>
  </div>

  <div className={styles.path}>
    <h3>The path to recommendations</h3>
    <p className="bold">The Global Commission proceeded in four phases:</p>
    <img src={pathImg} alt="" />
  </div>

  <div className={styles.steps}>
    <div className={styles.section}>
      <span className={styles.number}>01</span>
      <hr/>
      <h3>Review of democratic experiences during COVID-19</h3>
      <p>The Global Commission first reviewed the impact of COVID-19 on democracy, drawing on the diverse and dynamic experiences of democratic countries around the world during the first year of the pandemic.</p>
      <Button href="https://www.clubmadrid.org/wp-content/uploads/2021/05/Global-Commission-Background-Paper-12-May.pdf" text="Read the Global <span class='nowrap'> Commission's Background Paper</span>"/>
    </div>
    <div className={styles.section}>
      <span className={styles.number}>02</span>
      <hr/>
      <h3>THEMATIC WORKING GROUPS</h3>
      <p>The Global Commission articulated its reflections around three thematic clusters: the mechanisms of democracy and fundamental rights; social inclusion; and effective leadership and democratic culture. A Working Group on each cluster brought together commissioners with selected external experts, under the guidance of a knowledge partner who provided data, analysis and a basic framework for their reflections.</p>
      <div className={styles.cards} >
        <div className={styles.col} style={{backgroundImage: "url(" + card1 +")"}}>
          <h4>Working Group 1:</h4>
          <p className="bold">Mechanisms of democracy <br/>and fundamental rights</p>
          <p className={styles.description}>With <span className="bold">International IDEA</span> as knowledge partner, WG1 identified gaps and good practices to protect basic democratic institutions, check and balances, fundamental rights and the rule of law in emergency situations.</p>
          <Button href="https://www.clubmadrid.org/wp-content/uploads/2021/12/WG-1-IDEA.pdf" text="Read the Issues Paper"/>
        </div>
        <div className={styles.col} style={{backgroundImage: "url(" + card2 +")"}}>
          <h4>Working Group 2:</h4>
          <p className="bold">Social inclusion<br/><br/></p>
          <p className={styles.description}>With <span className="bold">Oxfam International</span> as knowledge partner, WG2 looked into protecting and promoting social inclusion in emergencies, by alleviating pressures associated with rising inequalities within and between countries.</p>
          <Button href="https://www.clubmadrid.org/wp-content/uploads/2021/12/WG-2-OXFAM.pdf" text="Read the Issues Paper"/>
        </div>
        <div className={styles.col} style={{backgroundImage: "url(" + card3 +")"}}>
          <h4>Working Group 3:</h4>
          <p className="bold">Effective leadership <br/>and democratic culture</p>
          <p className={styles.description}>With <span className="bold">Edelman</span> as knowledge partner, WG3 identified analyzed dynamics of trust and leadership in the face of uncertainty, when the imperative for quick action pose extraordinary challenges for decision-makers.</p>
          <Button href="https://www.clubmadrid.org/wp-content/uploads/2021/12/WG-3-Edelman.pdf" text="Read the Issues Paper"/>
        </div>
      </div>
    </div>
    <div className={styles.section}>
      <span className={styles.number}>03</span>
      <hr/>
      <h3>Regional consultations</h3>
      <p>The Global Commission hosted Live Sessions with regional experts on issues that bore particular relevance in Asia-Pacific, Africa & the Middle East, and Latin America & the Caribbean.</p>

      <div className={styles.videos}>
        <div className={styles.col}>
          <Video href="https://www.youtube.com/watch?v=fCTmgRCz3xI" bg={video1}/>
          <h4>Policy success through anticipation - How to build a democratic culture of emergency preparedness?</h4>
        </div>
        <div className={styles.col}>
          <Video href="https://www.youtube.com/watch?v=wUtbEK5K9u0" bg={video2}/>
          <h4>Delivering for youth in emergency response and recovery</h4>
        </div>
        <div className={styles.col}>
          <Video href="https://www.youtube.com/watch?v=1Wslcj7-4qs" bg={video3}/>
          <h4>Building trust between citizens and public institutions in emergency situations</h4>
        </div>

    </div>

    </div>
    <div className={styles.section}>
      <span className={styles.number}>04</span>
      <hr/>
      <h3>Deliberations on the way forward</h3>
      <p>The Global Commission on Democracy and Emergencies was formed by 16 Commissioners: former Heads of State or Government and current leaders from international and civil society organizations, academia and media. The Commissioners participated in work sessions, deliberations, and regional consultations over the course of nine months to identify good practices and lessons learned, drawing on the experience of COVID-19 in democracies around the world.</p>
      <Button href="https://www.clubmadrid.org/wp-content/uploads/2021/12/Global-Commission_Report_DIGITAL.pdf" text="Read the Global Commission’s full report"/>
    </div>
  </div>

  </div>;
}
